import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPageHeader } from '../../molecules/page-header/ContentPageHeader';
import { TRY_THEN_BUY } from '../../../constants/define/translation';

interface TTBPageHeaderProps {}

export const TTBPageHeader = (props: TTBPageHeaderProps) => {
  const { t } = useTranslation(TRY_THEN_BUY);
  // const extra: ExtraHeaderPage[] = [
  //   {
  //     key: 1,
  //     text: t('header.buttonCreate'),
  //     bgWhite: 'true',
  //     onClick: () => props.setIsOpenModal(true),
  //     icon: <IconCreateBlack />,
  //   },
  // ];

  return <ContentPageHeader title={t('header.title')} />;
};
